// extracted by mini-css-extract-plugin
export default {"formula":"formula__v9VDPbBE","definition":"definition__gAra1M3o","input":"input__VHUTDFHM","referencedMetrics":"referenced-metrics__kFCbTuAM","measurement":"measurement__etm4Svqs"};